// This file was automatically generated from tourguide.tease.html.
// Please don't edit this file by hand.

goog.provide('el8.template.tourguide.tease');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.introSplash = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideDialogContainer"><div><h1>Information at your fingertips instantly</h1><div><p>You\'ll learn to love the convenience of the Clinical Profile and the power of our smart Chronological Record. But for now, let\'s look at how Elation quickly gets you the context you need to care for patients.</span></p><div class="tourSplashButtonContainer"><a class="start-trigger tourGuideButton">Show Me the Demo!</a></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.endSplash = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideDialogContainer"><div><h1>Thanks for Touring Elation!</h1><div><h3>Search is just one of our many powerful features.</h3><h3 class="mt10">To speak with someone at Elation or request a demo:</h3><div class="tourSplashButtonContainer mb20"><a target="_blank" rel="noopener" href="https://www.elationhealth.com/contact-us" class="cta-trigger contact-us tourGuideButton">Reach us</a></div><h3>If you\'d like to keep poking around on this sample chart:</h3><div class="tourSplashButtonContainer"><a target="_blank" rel="noopener" class="end-trigger tourGuideButtonBlue">Continue exploring</a></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.introVisor = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Click on the X here to continue with the tour.</p></div><div class="tourGuideInfoBoxPointerTopRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.shareBox = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="tour-share-trigger tourShareCta">Share!</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.visorContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visor-content teaserVisorContainer"><div class="teaserVisorText"><p class="teaserTitle">Patient Chart Demo</p><div class="teaserProgressContainer"><ol class="visor-nav teaserProgressSectionWrap"></ol></div></div><div class="teaserVisorButtonContainer"><ul class="teaserButtonContainer"><li class="teaserButtonWrapInline"><span class="teaserTopPadding"><a class="tour-restart-trigger teaserLink">Restart Tour</a></span></li><li class="teaserButtonWrapInline"><span class="teaserTopPadding"><a class="tour-end-trigger teaserLink">Exit Tour</a></span></li><li class="teaserButtonWrapInline"><a class="cta-trigger contact-us tourGuideCTAButton tourGuideCTAOrange" target="_blank" rel="noopener" href="https://www.elationhealth.com/contact-us">Let Us Reach You</a></li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.visorSlideNav = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="teaserProgressSectionItem"><a class="progress-trigger" _name="', soy.$$escapeHtml(opt_data.name), '">', soy.$$escapeHtml(opt_data.caption), '</a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.cholesterolResults = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Everything in the patient\'s record that references "Cholesterol" is also displayed, including visit notes, lab reports, medications, and more.</p><div class="tourGuideInfoBoxButtonContainer"><a class="next-trigger tourGuideInfoBoxButton">Next &#8594;</a></div></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.cholesterolResultsMagicTable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Cholesterol and related lab results are trended and displayed. Abnormal values are in red.</p><div class="tourGuideInfoBoxButtonContainer"><a class="next-trigger tourGuideInfoBoxButton">Next &#8594;</a></div></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.cholesterolResultClick = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Click on a lab result to view the entire original report.</p></div><div class="tourGuideInfoBoxPointerTop"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.reportsOverlay = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Scroll down the dialog to view other reports. Click the "X" to close the dialog.</p></div><div class="tourGuideInfoBoxPointerBottom"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.clearSearch = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Click the "X" to leave Search Results mode and see the whole chart again.</p></div><div class="tourGuideInfoBoxPointerTopRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchCleared = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>You can now view the whole chart again.</p><div class="tourGuideInfoBoxButtonContainer"><a class="next-trigger tourGuideInfoBoxButton">Next &#8594;</a></div></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.xwalkNotifier = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Elation uses intelligent search to make the ICD-10 transition a breeze.</p><p>To see how easy it is to add ICD-10s to an existing problem, click on <span class="infoBoxEmphasis">CHF w Cardiomyopathy</span>.</p></div><div class="tourGuideInfoBoxPointerLeft"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.problemDialog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Select an appropriate diagnosis below, then click "Save & Crosswalk Another" to continue.</p></div><div class="tourGuideInfoBoxPointerBottom"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.problemDialogXwalkAnother = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>That\'s all it takes! Continue crosswalking, and click "Save" or "Discard" when you\'re ready to stop.</p></div><div class="tourGuideInfoBoxPointerBottom"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.chartInfoSplash = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Click to continue.</p></div><div class="tourGuideInfoBoxPointerRight" style="top: 5px;"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchCholesterol = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Now that we\'re refreshed on the patient\'s diagnoses, let\'s review past labs. Just hit "Enter" to search for past <span class="infoBoxEmphasis">cholesterol</span> results.</p></div><div class="tourGuideInfoBoxPointerTop"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchCholesterolAgain = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Oops. Looks like a spelling error. Let\'s try again! Type <span class="infoBoxEmphasis">Cholesterol</span> and hit "Enter" on your keyboard.</p></div><div class="tourGuideInfoBoxPointerTop"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchFreeText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>You can also search for any text in the chart to quickly refresh your memory. E.g., <span class="infoBoxEmphasis">ckd</span> or <span class="infoBoxEmphasis">glucose</span>.</p></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchTextAgain = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Oops. No results found. Check the spelling and try again!</p></div><div class="tourGuideInfoBoxPointerTop"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.searchResults = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Here are the results of your search.</p><div class="tourGuideInfoBoxButtonContainer"><a class="next-trigger tourGuideInfoBoxButton">Next &#8594;</a></div></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.tease.exploreSearch = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideInfoBoxContainer"><p>Continue exploring Search. Try filtering for <span class="infoBoxEmphasis">visit notes</span> or <span class="infoBoxEmphasis">reports</span>.</p></div><div class="tourGuideInfoBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};
